import React, { useEffect, useState } from "react";
import { API_URL } from "../../../const.js";
import { Button } from "antd";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

const ExpandOnHistory = ({
    video,
    collection,
    visibleExpandsOnHistory,
    onItemClick,
    onExpandOnHistoryToggle,
    clickedQuestionIds
}) => {
    const [historyList, setHistoryList] = useState([]);

    const fetchExpandOnHistory = (id) => {
        // Safety check: ensure collection and id exist
        if (!collection?.id || !id) {
            console.error("Missing collection.id or video id");
            setHistoryList([]);
            return;
        }
        
        fetch(API_URL + `/api/v1/gpt/last-expand-on/${collection.id}/${id}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("access")
            }
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Network response was not ok");
                }
            })
            .then((response) => {
                if (response.data) {
                    setHistoryList(response.data);
                } else {
                    // If no data, set empty array
                    setHistoryList([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching suggested questions:", error);
                // On error, set empty array to prevent stale data
                setHistoryList([]);
            });
    };

    const toggleExpandItems = () => {
        onExpandOnHistoryToggle(!visibleExpandsOnHistory);
    };

    useEffect(() => {
        if (video && collection?.id) {
            fetchExpandOnHistory(video);
        }
    }, [video, collection?.id]);

    return (
        <div
            id="expand-on-history-list"
            className={`expand-on-history-list-items ${
                visibleExpandsOnHistory ? "open" : ""
            } ${historyList.length > 0 ? "visible" : ""}`}>
            {historyList.length > 0 && (
                <>
                    <div className="header" onClick={() => toggleExpandItems()}>
                        <h2>Suggested questions</h2>
                        <Button
                            size="small"
                            shape="circle"
                            type="link"
                            icon={
                                visibleExpandsOnHistory ? (
                                    <FaChevronDown />
                                ) : (
                                    <FaChevronUp />
                                )
                            }></Button>
                    </div>
                    {visibleExpandsOnHistory && (
                        <>
                            {historyList.map((history, index) => {
                                // Safety check: skip invalid history items
                                if (!history || !history.question || history.id === undefined) {
                                    return null;
                                }
                                
                                return (
                                    <div
                                        className={`expand-on-history-list-item user-box ${
                                            clickedQuestionIds && clickedQuestionIds.has(history.id) ? "clicked-suggestion" : ""
                                        }`}
                                        key={history.id || index}
                                        onClick={() => onItemClick(history)}>
                                        {history.question}
                                    </div>
                                );
                            })}
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default ExpandOnHistory;
